import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const belleairShoreConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Belleair Shore Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Belleair Shore, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_belleair_shore',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Belleair Shore',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Belleair Shore Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the upscale waterfront 
     properties of <strong>Belleair Shore</strong> with the same level of care 
     and professionalism this community expects. As one of Florida's smallest 
     municipalities, Belleair Shore is defined by its stunning Gulf front estates 
     and the mature trees that frame them. When those trees become hazards from 
     storm damage or overgrowth, our team handles removal and trimming with precision 
     and respect for your property.`,

    `We specialize in <strong>high care tree removal and trimming on estate level 
     properties</strong> storm compromised canopies, large overhanging limbs near 
     premium structures, palms weakened by salt and wind, and trees that require 
     careful rigging and removal to avoid damage to landscaping, pools, and 
     surrounding hardscape.`,

    `<strong>Sam's Tree Service</strong> brings trusted, professional tree care 
     to <strong>Belleair Shore</strong> and the surrounding <strong>Belleair 
     and Pinellas Gulf coast</strong> area delivering the quality and reliability 
     that exceptional properties deserve.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Belleair Shore, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_BelleairShore = () => <LocationPage config={belleairShoreConfig} />;
export default Services_BelleairShore;
